<template>
		<div id="pageRoot" class="backgroundDeaf" style="background-color: var(--book-background-color)">
			<div class="pageSVG">
				<img src="/pages/img/sordo2/svgPage8a.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<uploaded-image class="image-top pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></uploaded-image>					
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->
			<div id="buttonUploadImage01" style="position: absolute; margin-left: 16%; margin-top: 67%;">
				<ImageUpload v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></ImageUpload>
			</div>
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->

		<!-- TEXTOS -------------------------------------------------------------------------------------------------------->
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=1 class="name pageTextNormalDeaf black-text"/>
			<saved-input v-bind:page="$parent.page" v-bind:type="$parent.type" number=2 class="age pageTextNormalDeaf black-text"/>
		<!-- TEXTOS -------------------------------------------------------------------------------------------------------->

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
@import '../../../assets/css/sordoStyle.css';
.name{
	width:340px;
	margin-left: 62%;
	margin-top: 54.5%;
	font-size: 45px;
	position:absolute;
}
.age {
	margin-left: 56%;
	margin-top: 62%;
	width:160px;
	font-size: 45px;
	position:absolute;
}
.image-top{
	position:absolute;
    left: 20%;
    top: 60%;
    width: 600px;
    height: 450px;
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>